import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../../../../components/CustomTextField";
import useTenant from "../../../../../hooks/useTenant";
import useAuth from "../../../../../hooks/useAuth";
import useSmsProvider from "../../../../../hooks/useSmsProvider";
import SearchableAutoComplete from "../../../../../components/SearchableAutoComplete";

const currentSmsProviderPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const currentTenantPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const SmsApi = (props) => {
  const { user } = useAuth();
  const { validationFields } = props;
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext();
  const { t } = useTranslation();

  const { autoSearchSmsProvider, smsProviderAutoSearchResults } = useSmsProvider();

  const [smsProviderPayload, setSmsProviderPayload] = useState(currentSmsProviderPayload);
  const [smsProviderOptions, setSmsProviderOptions] = useState([]);

  const fetchSmsProviders = async () => {
    await autoSearchSmsProvider(smsProviderPayload);
  };

  useEffect(() => {
    fetchSmsProviders();
  }, [smsProviderPayload]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (smsProviderAutoSearchResults.data.length !== 0) {
      const results = [...smsProviderOptions, ...smsProviderAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      console.log(filteredResults, "filteredResults");
      setSmsProviderOptions(filteredResults);
    }
  }, [smsProviderAutoSearchResults]);

  const [businessType, setBusinessType] = useState(["SUPER_ADMIN", "MULTI_SERVICE_OPERATOR"]);

  return (
    <Grid container spacing={12} className="row" pt={8}>
      {user && businessType.includes(user.businessType) && (
        <Grid item xs={10} sm={12} md={6} lg={6} xl={4}>
          <SearchableAutoComplete
            control={control}
            data={smsProviderOptions}
            label={t("select_smsProvider")}
            payload={smsProviderPayload}
            setPayload={setSmsProviderPayload}
            loading={false}
            name="smsProvider"
            multiple={false}
            defaultValue={""}
            hasNextPage={false}
            fields={validationFields}
          />
        </Grid>
      )}

      <Grid item md={6}>
        <CustomTextField
          label={t("userName")}
          name="smsUserName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>

      <Grid item md={6}>
        <CustomTextField
          label={t("password")}
          name="smsPassword"
          type="password"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
    </Grid>
  );
};

export default SmsApi;
